const heroBase = require('../models/game_state/heroes');
const mobBase = require('../models/game_pieces/ai_units/mobs');
const summonedBase = require('../models/game_pieces/ai_units/summoned_units');

const unitBase = {
  ...heroBase,
  ...mobBase,
  ...summonedBase,
};

const getAbilityLevel = function ({ ability_handle, tree_handle, unit_build }) {
  if (!ability_handle) {
    throw new Error('[getAbilityLevel] no ability_handle');
  }
  if (!unit_build) {
    throw new Error('[getAbilityLevel] no unit_build');
  }

  let abilityTree;
  if (!tree_handle || unit_build.ai_unit) {
    let abilityTrees = unit_build.ability_trees || unit_build.abilityTrees;
    if (!abilityTrees && unit_build?.getAbilityTrees) {
      abilityTrees = unit_build?.getAbilityTrees();
    }
    if (!abilityTrees) {
      abilityTrees = unitBase[unit_build.hero_handle || unit_build.handle]?.getAbilityTrees();
    }
    if (!abilityTrees) {
      throw new Error('invalid unit_build');
    }

    if (!Array.isArray(abilityTrees) && typeof abilityTrees === 'object') {
      abilityTrees = Object.values(abilityTrees);
    }

    abilityTree = abilityTrees.find((tree) => Object.keys(tree.abilities).includes(ability_handle));
    if (!abilityTree) {
      return 0;
    }
  }

  // AI units' ability levels are stored as ability.level
  const ability = abilityTree?.abilities[ability_handle];
  if (ability?.level) {
    return ability.level;
  }

  // heroes ability levels are stored as ability_upgrades
  const upgrades_by_tree = (unit_build.ability_upgrades || {})[tree_handle || abilityTree.handle];
  return upgrades_by_tree ? upgrades_by_tree[ability_handle] || 0 : 0;
};
module.exports = getAbilityLevel;
